import { get, getOr, first, flow, constant } from 'lodash/fp';

import setCustomerInfoForShippingInfo from '../../saveCustomerInfoForShippingPage';

export default (cartingOptions) => {
  const job = get('job', cartingOptions);

  return flow(
    () => setCustomerInfoForShippingInfo(
      {
        ...getOr({}, 'address', job),
        zipCode: get('address.zipcode', job),
      },
      {
        ...getOr({}, 'customer', job),
        homePhone: flow(
          get('customer.phones'),
          first,
          get('number'),
        )(job),
      },
    ),
    constant(cartingOptions),
  )(cartingOptions);
};
